
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";
import AgentCard from "@/components/AgentCard";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { Search } from "lucide-react";

interface Agent {
  id: string;
  title: string;
  description: string;
  price: string;
  icon: string;
}

const agents: Agent[] = [
  {
    id: "legal-research",
    title: "Legal research for New Zealand law",
    description: "Process and analyze legal data with AI-powered insights",
    price: "$750/Month",
    icon: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?auto=format&fit=crop&w=300&q=70&fm=webp"
  },
  {
    id: "analysis-bot",
    title: "DubCity AI Analysis Bot",
    description: "Analyze stocks and cryptocurrencies with DubCity AI Analysis Bot",
    price: "$750/Month",
    icon: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=300&q=70&fm=webp"
  },
  {
    id: "custom-agent",
    title: "Custom Agent",
    description: "Describe how you want your agent to function we build it you use it",
    price: "Custom Pricing",
    icon: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=300&q=70&fm=webp"
  }
];

const Agents = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredAgents = agents.filter(agent =>
    agent.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    agent.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50">
      <Header />
      <main className="flex-grow pt-24 pb-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center mb-8 text-primary animate-fade-in">
            Our AI Agents
          </h1>
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
            Discover our specialized AI agents designed to transform your business operations.
          </p>
          
          <div className="relative max-w-md mx-auto mb-12">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <Input
              type="text"
              placeholder="Search agents..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 w-full border-2 focus:border-accent"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredAgents.map((agent) => (
              <AgentCard key={agent.id} {...agent} />
            ))}
            {filteredAgents.length === 0 && (
              <div className="col-span-full text-center text-gray-500 py-12 bg-white rounded-lg shadow-sm">
                No agents found matching your search criteria
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Agents;
